import { render, staticRenderFns } from "./district-list.vue?vue&type=template&id=4f5fb3da&"
import script from "./district-list.vue?vue&type=script&lang=js&"
export * from "./district-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports